//mobile only JM customization

$(document).ready(function(){
    if(window.matchMedia("(max-width: 767px)").matches){
      //initial
$(function(){ correctjm() });
 document.addEventListener('focus', function() {
correctjm();
  }, true);

    }
});

function correctjm(){
// putting profile name before review stars.
$(function() {
  $(".jdgm-rev__header>.jdgm-row-profile").each(function() {
    $(this).insertBefore($(this).prev())
  });
});

// putting verified badge before name for styling.
$(function() {
  $(".jdgm-rev__author-wrapper>.jdgm-rev__buyer-badge-wrapper").each(function() {
    $(this).insertBefore($(this).prev())
  });
});

  //text change
  $(".jdgm-rev__buyer-badge").html("Verified Customer");
}